export default "__VITE_ASSET__DzJikoYo__"